/**
 * Vesper Right Now Service (Shared)
 */

import apiClient from './api.client';
import { API } from '../constants/api';
import { bustByPrefix } from './dedupedFetch';
import type { RightNowPost, CreateRightNowPayload } from '../types/right_now.types';

export async function createRightNow(payload: CreateRightNowPayload): Promise<RightNowPost> {
  const res = await apiClient.post<{ success: true; data: RightNowPost }>(
    API.RIGHT_NOW,
    payload,
  );
  // The new RN post must surface in the Map's nearby feed for the user
  // (and anyone else). Bust every cached geo:nearbyAll key (varies by
  // lat/lng/radius) so the next read picks up the new post.
  bustByPrefix('geo:nearbyAll:');
  return res.data.data;
}

/**
 * Upload photo. Accepts a FormData-compatible body.
 * Web: pass File. Mobile: pass { uri, name, type } via FormData.
 */
export async function uploadPhoto(formData: FormData): Promise<{ url: string }> {
  const res = await apiClient.post<{ success: true; data: { url: string } }>(
    API.RIGHT_NOW_UPLOAD,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return res.data.data;
}

export async function getRightNowFeed(lat?: number, lng?: number): Promise<RightNowPost[]> {
  const params = new URLSearchParams();
  if (lat != null) params.set('lat', String(lat));
  if (lng != null) params.set('lng', String(lng));
  const query = params.toString();
  const res = await apiClient.get<{ success: true; data: RightNowPost[] }>(
    `${API.RIGHT_NOW_FEED}${query ? `?${query}` : ''}`,
  );
  return res.data.data;
}

export async function getMyRightNow(): Promise<RightNowPost[]> {
  const res = await apiClient.get<{ success: true; data: RightNowPost[] }>(API.RIGHT_NOW_MINE);
  return res.data.data;
}

export async function deleteRightNow(id: string): Promise<void> {
  await apiClient.delete(API.RIGHT_NOW_DELETE(id));
  bustByPrefix('geo:nearbyAll:');
}
